import { createFileRoute } from '@tanstack/react-router';
import { IndicadoresPage } from '../../../indicadores/indicadores-page.tsx';

export const Route = createFileRoute('/indicadores/')({
  component: IndicadoresPage,
});
